import DashboardPage from "@pages/dashboard";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/")({
	component: DashboardPage,
	staticData: {
		breadcrumbId: "page.dashboard.title",
		breadcrumbTitle: "Dashboard",
	},
});
